import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1749549570357,
      error: null,
      object: 'calculateofferforknownperiodandriskbyid',
      success: true,
      data: {
        loanAmount: 700000,
        period: 8,
        borrower: [
          {
            fullName: 'ירדן',
            idNumber: '211890744',
            phoneNumber: '0586182000',
            dob: '2000-06-17T21:00:00.000Z',
            idIssueDate: '2000-06-17T21:00:00.000Z',
            email: 'yard@gmail.com',
            city: 'טללים',
            address: 'גד',
          },
        ],
        mixes: [
          {
            risk: 0,
            totalAdditionalAmountDueToAdditionalFee: 0,
            disposalBoard: [
              {
                period: 1,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 4062.4999999999995,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2468.446745413318,
                fundBalance: 1000000,
              },
              {
                period: 2,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 4052.4765577634403,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2478.4701876498775,
                fundBalance: 997531.5532545866,
              },
              {
                period: 3,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 4042.412380856952,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2488.5343645563657,
                fundBalance: 995053.0830669368,
              },
              {
                period: 4,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 4032.307303599372,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2498.6394418139453,
                fundBalance: 992564.5487023804,
              },
              {
                period: 5,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 4022.161159635088,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2508.7855857782297,
                fundBalance: 990065.9092605663,
              },
              {
                period: 6,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 4011.973781931286,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2518.9729634820314,
                fundBalance: 987557.1236747883,
              },
              {
                period: 7,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 4001.7450027751947,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2529.2017426381226,
                fundBalance: 985038.1507113061,
              },
              {
                period: 8,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3991.474653771314,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2539.4720916420038,
                fundBalance: 982508.948968668,
              },
              {
                period: 9,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3981.1625658386324,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2549.7841795746854,
                fundBalance: 979969.4768770261,
              },
              {
                period: 10,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3970.8085692078344,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2560.1381762054834,
                fundBalance: 977419.6926974514,
              },
              {
                period: 11,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3960.4124934184974,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2570.53425199482,
                fundBalance: 974859.5545212459,
              },
              {
                period: 12,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3949.9741673162744,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2580.972578097043,
                fundBalance: 972289.0202692511,
              },
              {
                period: 13,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3939.493419050068,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2591.4533263632493,
                fundBalance: 969708.0476911541,
              },
              {
                period: 14,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3928.9700760691885,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2601.976669344129,
                fundBalance: 967116.5943647908,
              },
              {
                period: 15,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3918.4039651205076,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2612.5427802928098,
                fundBalance: 964514.6176954467,
              },
              {
                period: 16,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3907.7949122455943,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2623.151833167723,
                fundBalance: 961902.0749151538,
              },
              {
                period: 17,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3897.142742777841,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2633.804002635477,
                fundBalance: 959278.9230819861,
              },
              {
                period: 18,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3886.447281339577,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2644.4994640737414,
                fundBalance: 956645.1190793507,
              },
              {
                period: 19,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3875.7083518391737,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2655.2383935741436,
                fundBalance: 954000.6196152768,
              },
              {
                period: 20,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3864.9257774681364,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2666.020967945181,
                fundBalance: 951345.3812217028,
              },
              {
                period: 21,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3854.0993806981787,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2676.8473647151395,
                fundBalance: 948679.3602537576,
              },
              {
                period: 22,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3843.2289832782926,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2687.717762135025,
                fundBalance: 946002.5128890425,
              },
              {
                period: 23,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3832.314406231805,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2698.632339181512,
                fundBalance: 943314.7951269075,
              },
              {
                period: 24,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3821.35546985342,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2709.5912755598974,
                fundBalance: 940616.1627877259,
              },
              {
                period: 25,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3810.3519937062483,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2720.5947517070695,
                fundBalance: 937906.5715121661,
              },
              {
                period: 26,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3799.3037966188276,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2731.6429487944906,
                fundBalance: 935185.9767604591,
              },
              {
                period: 27,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3788.2106966821293,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2742.7360487311885,
                fundBalance: 932454.3338116645,
              },
              {
                period: 28,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3777.0725112465548,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2753.874234166763,
                fundBalance: 929711.5977629335,
              },
              {
                period: 29,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3765.8890569189152,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2765.057688494402,
                fundBalance: 926957.7235287667,
              },
              {
                period: 30,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3754.660149559404,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2776.2865958539137,
                fundBalance: 924192.6658402723,
              },
              {
                period: 31,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3743.385604278552,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2787.561141134766,
                fundBalance: 921416.3792444183,
              },
              {
                period: 32,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3732.0652354341755,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2798.881509979142,
                fundBalance: 918628.8181032836,
              },
              {
                period: 33,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3720.698856628308,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2810.2478887850093,
                fundBalance: 915829.9365933044,
              },
              {
                period: 34,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3709.28628070412,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2821.660464709197,
                fundBalance: 913019.6887045193,
              },
              {
                period: 35,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3697.8273197428284,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2833.1194256704894,
                fundBalance: 910198.0282398101,
              },
              {
                period: 36,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3686.3217850605897,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2844.624960352728,
                fundBalance: 907364.9088141397,
              },
              {
                period: 37,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3674.7694872053844,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2856.1772582079334,
                fundBalance: 904520.2838537869,
              },
              {
                period: 38,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3663.1702359538867,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2867.7765094594315,
                fundBalance: 901664.1065955788,
              },
              {
                period: 39,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3651.523840308319,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2879.4229051049983,
                fundBalance: 898796.3300861195,
              },
              {
                period: 40,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3639.830108493301,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2891.1166369200164,
                fundBalance: 895916.9071810145,
              },
              {
                period: 41,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3628.0888479526766,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2902.8578974606407,
                fundBalance: 893025.7905440945,
              },
              {
                period: 42,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3616.2998653463337,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2914.6468800669836,
                fundBalance: 890122.9326466339,
              },
              {
                period: 43,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3604.462966547012,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2926.483778866306,
                fundBalance: 887208.2857665669,
              },
              {
                period: 44,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3592.577956637091,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2938.368788776226,
                fundBalance: 884281.8019877005,
              },
              {
                period: 45,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3580.6446399053752,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2950.3021055079425,
                fundBalance: 881343.4331989242,
              },
              {
                period: 46,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3568.6628198438543,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2962.2839255694635,
                fundBalance: 878393.1310934164,
              },
              {
                period: 47,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3556.6322991444604,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2974.314446268857,
                fundBalance: 875430.847167847,
              },
              {
                period: 48,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3544.5528796958065,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2986.3938657175113,
                fundBalance: 872456.5327215781,
              },
              {
                period: 49,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3532.424362579913,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 2998.5223828334047,
                fundBalance: 869470.1388558606,
              },
              {
                period: 50,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3520.2465480689207,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3010.7001973443967,
                fundBalance: 866471.616473027,
              },
              {
                period: 51,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3508.019235621792,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3022.9275097915256,
                fundBalance: 863460.9162756826,
              },
              {
                period: 52,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3495.742223880994,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3035.2045215323233,
                fundBalance: 860437.9887658912,
              },
              {
                period: 53,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3483.415310669176,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3047.5314347441417,
                fundBalance: 857402.7842443589,
              },
              {
                period: 54,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3471.0382929858233,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3059.908452427494,
                fundBalance: 854355.2528096146,
              },
              {
                period: 55,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3458.6109670039077,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3072.3357784094096,
                fundBalance: 851295.3443571872,
              },
              {
                period: 56,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3446.133128066517,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3084.8136173468,
                fundBalance: 848223.0085787778,
              },
              {
                period: 57,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3433.604570683473,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3097.342174729845,
                fundBalance: 845138.194961431,
              },
              {
                period: 58,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3421.0250885279356,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3109.9216568853817,
                fundBalance: 842040.8527867012,
              },
              {
                period: 59,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3408.3944744329965,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3122.552270980321,
                fundBalance: 838930.9311298159,
              },
              {
                period: 60,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3395.712520388252,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3135.234225025066,
                fundBalance: 835808.3788588354,
              },
              {
                period: 61,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3382.979017536367,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3147.967727876951,
                fundBalance: 832673.1446338105,
              },
              {
                period: 62,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3370.193756169623,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3160.752989243694,
                fundBalance: 829525.1769059335,
              },
              {
                period: 63,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3357.356525726457,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3173.59021968686,
                fundBalance: 826364.4239166898,
              },
              {
                period: 64,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3344.4671147879753,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3186.479630625342,
                fundBalance: 823190.8336970031,
              },
              {
                period: 65,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3331.5253110744643,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3199.4214343388535,
                fundBalance: 820004.3540663777,
              },
              {
                period: 66,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3318.5309014418795,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3212.4158439714383,
                fundBalance: 816804.9326320388,
              },
              {
                period: 67,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3305.4836718783263,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3225.463073534991,
                fundBalance: 813592.5167880674,
              },
              {
                period: 68,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3292.3834075005225,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3238.5633379127953,
                fundBalance: 810367.0537145324,
              },
              {
                period: 69,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3279.2298925502446,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3251.7168528630737,
                fundBalance: 807128.4903766196,
              },
              {
                period: 70,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3266.022910390765,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3264.9238350225523,
                fundBalance: 803876.7735237565,
              },
              {
                period: 71,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3252.7622435032727,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3278.1845019100447,
                fundBalance: 800611.8496887339,
              },
              {
                period: 72,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3239.4476734832742,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3291.499071930043,
                fundBalance: 797333.6651868238,
              },
              {
                period: 73,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3226.078981036988,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3304.8677643763294,
                fundBalance: 794042.1661148937,
              },
              {
                period: 74,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3212.65594597772,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3318.2907994355974,
                fundBalance: 790737.2983505174,
              },
              {
                period: 75,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3199.178347222223,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3331.7683981910945,
                fundBalance: 787419.0075510818,
              },
              {
                period: 76,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3185.6459627870445,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3345.3007826262733,
                fundBalance: 784087.2391528907,
              },
              {
                period: 77,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3172.0585697848564,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3358.888175628462,
                fundBalance: 780741.9383702645,
              },
              {
                period: 78,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3158.4159444207735,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3372.530800992544,
                fundBalance: 777383.050194636,
              },
              {
                period: 79,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3144.7178619886536,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3386.2288834246638,
                fundBalance: 774010.5193936436,
              },
              {
                period: 80,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3130.964096867384,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3399.9826485459334,
                fundBalance: 770624.2905102188,
              },
              {
                period: 81,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3117.154422517152,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3413.7923228961654,
                fundBalance: 767224.307861673,
              },
              {
                period: 82,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3103.288611475702,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3427.6581339376157,
                fundBalance: 763810.5155387768,
              },
              {
                period: 83,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3089.3664353545755,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3441.580310058742,
                fundBalance: 760382.8574048391,
              },
              {
                period: 84,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3075.3876648353375,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3455.55908057798,
                fundBalance: 756941.2770947805,
              },
              {
                period: 85,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3061.3520696657833,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3469.594675747534,
                fundBalance: 753485.7180142024,
              },
              {
                period: 86,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3047.2594186561373,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3483.68732675718,
                fundBalance: 750016.1233384549,
              },
              {
                period: 87,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3033.1094796752277,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3497.83726573809,
                fundBalance: 746532.4360116976,
              },
              {
                period: 88,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3018.9020196466536,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3512.044725766664,
                fundBalance: 743034.5987459596,
              },
              {
                period: 89,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 3004.636804544931,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3526.3099408683875,
                fundBalance: 739522.5540201929,
              },
              {
                period: 90,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2990.313599391622,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3540.633146021695,
                fundBalance: 735996.2440793244,
              },
              {
                period: 91,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2975.9321682514583,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3555.014577161859,
                fundBalance: 732455.6109333027,
              },
              {
                period: 92,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2961.492274228434,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3569.454471184884,
                fundBalance: 728900.5963561409,
              },
              {
                period: 93,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2946.9936794618934,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3583.9530659514244,
                fundBalance: 725331.141884956,
              },
              {
                period: 94,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2932.4361451225996,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3598.510600290718,
                fundBalance: 721747.1888190045,
              },
              {
                period: 95,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2917.8194314087873,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3613.1273140045305,
                fundBalance: 718148.6782187138,
              },
              {
                period: 96,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2903.1432975421967,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3627.8034478711206,
                fundBalance: 714535.5509047094,
              },
              {
                period: 97,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2888.407501764098,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3642.5392436492198,
                fundBalance: 710907.7474568381,
              },
              {
                period: 98,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2873.6118013312894,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3657.3349440820284,
                fundBalance: 707265.2082131889,
              },
              {
                period: 99,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2858.755952512091,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3672.190792901227,
                fundBalance: 703607.873269107,
              },
              {
                period: 100,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2843.8397105823115,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3687.107034831006,
                fundBalance: 699935.6824762058,
              },
              {
                period: 101,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2828.862829821205,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3702.083915592112,
                fundBalance: 696248.5754413747,
              },
              {
                period: 102,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2813.82506350741,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3717.1216819059077,
                fundBalance: 692546.4915257826,
              },
              {
                period: 103,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2798.726163914869,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3732.220581498448,
                fundBalance: 688829.3698438767,
              },
              {
                period: 104,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2783.565882308734,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3747.380863104583,
                fundBalance: 685097.1492623782,
              },
              {
                period: 105,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2768.34396894126,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3762.6027764720584,
                fundBalance: 681349.7683992736,
              },
              {
                period: 106,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2753.0601730476665,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3777.886572365651,
                fundBalance: 677587.1656228015,
              },
              {
                period: 107,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2737.714242842003,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3793.2325025713144,
                fundBalance: 673809.279050436,
              },
              {
                period: 108,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2722.30592551298,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3808.6408199003376,
                fundBalance: 670016.0465478647,
              },
              {
                period: 109,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2706.8349672197924,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3824.1117781935254,
                fundBalance: 666207.4057279644,
              },
              {
                period: 110,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2691.301113087923,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3839.645632325394,
                fundBalance: 662383.2939497707,
              },
              {
                period: 111,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2675.7041072049296,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3855.2426382083877,
                fundBalance: 658543.6483174453,
              },
              {
                period: 112,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2660.0436926162147,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3870.9030527971026,
                fundBalance: 654688.405679237,
              },
              {
                period: 113,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2644.3196113207764,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3886.6271340925414,
                fundBalance: 650817.5026264399,
              },
              {
                period: 114,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2628.5316042669447,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3902.4151411463727,
                fundBalance: 646930.8754923473,
              },
              {
                period: 115,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2612.6794113481,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3918.2673340652173,
                fundBalance: 643028.4603512009,
              },
              {
                period: 116,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2596.7627713983707,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3934.183974014947,
                fundBalance: 639110.1930171357,
              },
              {
                period: 117,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2580.781422188317,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3950.1653232250005,
                fundBalance: 635176.0090431208,
              },
              {
                period: 118,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2564.7351004205966,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3966.2116449927207,
                fundBalance: 631225.8437198957,
              },
              {
                period: 119,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2548.623541725612,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3982.3232036877057,
                fundBalance: 627259.632074903,
              },
              {
                period: 120,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2532.4464806571377,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 3998.5002647561796,
                fundBalance: 623277.3088712153,
              },
              {
                period: 121,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2516.2036506879354,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4014.743094725382,
                fundBalance: 619278.8086064592,
              },
              {
                period: 122,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2499.894784205344,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4031.051961207974,
                fundBalance: 615264.0655117338,
              },
              {
                period: 123,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2483.5196125068587,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4047.4271329064586,
                fundBalance: 611233.0135505258,
              },
              {
                period: 124,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2467.077865795688,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4063.8688796176293,
                fundBalance: 607185.5864176193,
              },
              {
                period: 125,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2450.5692731762906,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4080.377472237027,
                fundBalance: 603121.7175380017,
              },
              {
                period: 126,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2433.9935626499014,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4096.953182763416,
                fundBalance: 599041.3400657647,
              },
              {
                period: 127,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2417.350461110031,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4113.596284303287,
                fundBalance: 594944.3868830013,
              },
              {
                period: 128,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2400.6396943379523,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4130.307051075366,
                fundBalance: 590830.790598698,
              },
              {
                period: 129,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2383.8609869981656,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4147.085758415152,
                fundBalance: 586700.4835476226,
              },
              {
                period: 130,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2367.014062633849,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4163.932682779468,
                fundBalance: 582553.3977892075,
              },
              {
                period: 131,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2350.0986436622843,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4180.848101751033,
                fundBalance: 578389.465106428,
              },
              {
                period: 132,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2333.114451370271,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4197.832294043046,
                fundBalance: 574208.617004677,
              },
              {
                period: 133,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2316.061205909516,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4214.885539503802,
                fundBalance: 570010.7847106338,
              },
              {
                period: 134,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2298.938626292008,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4232.00811912131,
                fundBalance: 565795.89917113,
              },
              {
                period: 135,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2281.7464303853703,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4249.200315027947,
                fundBalance: 561563.8910520088,
              },
              {
                period: 136,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2264.484334908199,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4266.462410505119,
                fundBalance: 557314.6907369809,
              },
              {
                period: 137,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2247.1520554253757,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4283.794689987943,
                fundBalance: 553048.2283264757,
              },
              {
                period: 138,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2229.749306343367,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4301.197439069951,
                fundBalance: 548764.4336364878,
              },
              {
                period: 139,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2212.2758009055037,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4318.670944507814,
                fundBalance: 544463.2361974178,
              },
              {
                period: 140,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2194.731251187235,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4336.215494226082,
                fundBalance: 540144.56525291,
              },
              {
                period: 141,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2177.115368091373,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4353.831377321944,
                fundBalance: 535808.3497586839,
              },
              {
                period: 142,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2159.4278613433103,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4371.5188840700075,
                fundBalance: 531454.518381362,
              },
              {
                period: 143,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2141.668439486219,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4389.278305927099,
                fundBalance: 527082.9994972919,
              },
              {
                period: 144,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2123.8368098762353,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4407.1099355370825,
                fundBalance: 522693.7211913648,
              },
              {
                period: 145,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2105.9326786776173,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4425.0140667357,
                fundBalance: 518286.6112558277,
              },
              {
                period: 146,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2087.9557508578887,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4442.990994555429,
                fundBalance: 513861.5971890921,
              },
              {
                period: 147,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2069.9057301829594,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4461.041015230358,
                fundBalance: 509418.60619453667,
              },
              {
                period: 148,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2051.782319212227,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4479.1644262010905,
                fundBalance: 504957.5651793063,
              },
              {
                period: 149,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2033.5852192936602,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4497.361526119657,
                fundBalance: 500478.40075310523,
              },
              {
                period: 150,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 2015.314130558859,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4515.632614854459,
                fundBalance: 495981.03922698554,
              },
              {
                period: 151,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1996.9687519180966,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4533.977993495221,
                fundBalance: 491465.40661213105,
              },
              {
                period: 152,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1978.5487810553404,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4552.397964357977,
                fundBalance: 486931.42861863587,
              },
              {
                period: 153,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1960.0539144232548,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4570.892830990062,
                fundBalance: 482379.03065427794,
              },
              {
                period: 154,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1941.4838472381794,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4589.4628981751375,
                fundBalance: 477808.13782328786,
              },
              {
                period: 155,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1922.8382734750908,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4608.108471938227,
                fundBalance: 473218.6749251127,
              },
              {
                period: 156,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1904.1168858625415,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4626.829859550777,
                fundBalance: 468610.56645317446,
              },
              {
                period: 157,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1885.3193758775792,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4645.627369535738,
                fundBalance: 463983.73659362376,
              },
              {
                period: 158,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1866.4454337406453,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4664.501311672672,
                fundBalance: 459338.10922408797,
              },
              {
                period: 159,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1847.4947484104503,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4683.451997002867,
                fundBalance: 454673.6079124153,
              },
              {
                period: 160,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1828.4670075788335,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4702.479737834485,
                fundBalance: 449990.1559154124,
              },
              {
                period: 161,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1809.3618976655962,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4721.584847747721,
                fundBalance: 445287.67617757793,
              },
              {
                period: 162,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1790.1791038133165,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4740.767641600001,
                fundBalance: 440566.09132983023,
              },
              {
                period: 163,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1770.9183098821431,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4760.028435531174,
                fundBalance: 435825.3236882302,
              },
              {
                period: 164,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1751.5791984445677,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4779.36754696875,
                fundBalance: 431065.29525269906,
              },
              {
                period: 165,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1732.1614507801742,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4798.785294633144,
                fundBalance: 426285.9277057303,
              },
              {
                period: 166,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1712.6647468703686,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4818.281998542949,
                fundBalance: 421487.1424110972,
              },
              {
                period: 167,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1693.0887653930886,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4837.857980020229,
                fundBalance: 416668.86041255423,
              },
              {
                period: 168,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1673.4331837174873,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4857.5135616958305,
                fundBalance: 411831.002432534,
              },
              {
                period: 169,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1653.6976778985982,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4877.249067514719,
                fundBalance: 406973.48887083813,
              },
              {
                period: 170,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1633.881922671979,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4897.0648227413385,
                fundBalance: 402096.2398033234,
              },
              {
                period: 171,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1613.985591448332,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4916.961153964986,
                fundBalance: 397199.1749805821,
              },
              {
                period: 172,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1594.0083563081025,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4936.938389105215,
                fundBalance: 392282.2138266171,
              },
              {
                period: 173,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1573.9498879960565,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4956.996857417262,
                fundBalance: 387345.2754375119,
              },
              {
                period: 174,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1553.8098559158345,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4977.136889497483,
                fundBalance: 382388.2785800947,
              },
              {
                period: 175,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1533.5879281244845,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 4997.358817288833,
                fundBalance: 377411.1416905972,
              },
              {
                period: 176,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1513.2837713269732,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5017.662974086345,
                fundBalance: 372413.78287330834,
              },
              {
                period: 177,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1492.8970508706718,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5038.049694542646,
                fundBalance: 367396.119899222,
              },
              {
                period: 178,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1472.4274307398236,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5058.519314673494,
                fundBalance: 362358.07020467933,
              },
              {
                period: 179,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1451.8745735499847,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5079.072171863332,
                fundBalance: 357299.5508900059,
              },
              {
                period: 180,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1431.2381405424453,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5099.708604870872,
                fundBalance: 352220.4787181425,
              },
              {
                period: 181,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1410.517791578627,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5120.428953834691,
                fundBalance: 347120.77011327166,
              },
              {
                period: 182,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1389.7131851344566,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5141.233560278861,
                fundBalance: 342000.34115943697,
              },
              {
                period: 183,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1368.8239782947182,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5162.122767118599,
                fundBalance: 336859.1075991581,
              },
              {
                period: 184,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1347.849826747381,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5183.096918665937,
                fundBalance: 331696.98483203945,
              },
              {
                period: 185,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1326.7903847779057,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5204.156360635412,
                fundBalance: 326513.88791337353,
              },
              {
                period: 186,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1305.645305263525,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5225.301440149793,
                fundBalance: 321309.7315527382,
              },
              {
                period: 187,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1284.4142396675038,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5246.532505745814,
                fundBalance: 316084.4301125884,
              },
              {
                period: 188,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1263.0968380333736,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5267.849907379944,
                fundBalance: 310837.89760684257,
              },
              {
                period: 189,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1241.692748979145,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5289.253996434173,
                fundBalance: 305570.0476994626,
              },
              {
                period: 190,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1220.201619691495,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5310.745125721823,
                fundBalance: 300280.79370302847,
              },
              {
                period: 191,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1198.6230959199315,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5332.323649493386,
                fundBalance: 294970.0485773067,
              },
              {
                period: 192,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1176.9568219709354,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5353.989923442382,
                fundBalance: 289637.7249278132,
              },
              {
                period: 193,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1155.2024407020754,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5375.744304711242,
                fundBalance: 284283.73500437086,
              },
              {
                period: 194,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1133.359593516102,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5397.587151897215,
                fundBalance: 278907.9906996596,
              },
              {
                period: 195,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1111.4279203550154,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5419.518825058302,
                fundBalance: 273510.4035477624,
              },
              {
                period: 196,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1089.40705969411,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5441.539685719208,
                fundBalance: 268090.88472270407,
              },
              {
                period: 197,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1067.2966485359952,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5463.6500968773225,
                fundBalance: 262649.3450369849,
              },
              {
                period: 198,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1045.09632240459,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5485.850423008727,
                fundBalance: 257185.69494010758,
              },
              {
                period: 199,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1022.8057153390948,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5508.141030074223,
                fundBalance: 251699.84451709886,
              },
              {
                period: 200,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 1000.4244598879386,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5530.52228552538,
                fundBalance: 246191.70348702464,
              },
              {
                period: 201,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 977.9521871026996,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5552.994558310618,
                fundBalance: 240661.18120149928,
              },
              {
                period: 202,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 955.388526532003,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5575.558218881315,
                fundBalance: 235108.18664318867,
              },
              {
                period: 203,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 932.7331062153933,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5598.213639197924,
                fundBalance: 229532.62842430733,
              },
              {
                period: 204,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 909.9855526771812,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5620.961192736137,
                fundBalance: 223934.4147851094,
              },
              {
                period: 205,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 887.1454909202658,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5643.801254493052,
                fundBalance: 218313.4535923733,
              },
              {
                period: 206,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 864.2125444199314,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5666.7342009933855,
                fundBalance: 212669.65233788022,
              },
              {
                period: 207,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 841.1863351176194,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5689.7604102956975,
                fundBalance: 207002.91813688684,
              },
              {
                period: 208,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 818.0664834146733,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5712.880261998644,
                fundBalance: 201313.15772659116,
              },
              {
                period: 209,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 794.8526081660607,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5736.094137247257,
                fundBalance: 195600.2774645925,
              },
              {
                period: 210,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 771.5443266740676,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5759.40241873925,
                fundBalance: 189864.1833273453,
              },
              {
                period: 211,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 748.1412546819679,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5782.80549073135,
                fundBalance: 184104.78090860602,
              },
              {
                period: 212,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 724.643006367666,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5806.303739045652,
                fundBalance: 178321.97541787467,
              },
              {
                period: 213,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 701.0491943373155,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5829.897551076003,
                fundBalance: 172515.671678829,
              },
              {
                period: 214,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 677.3594296189096,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5853.587315794408,
                fundBalance: 166685.77412775301,
              },
              {
                period: 215,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 653.5733216558476,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5877.37342375747,
                fundBalance: 160832.1868119586,
              },
              {
                period: 216,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 629.6904783004723,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5901.256267112845,
                fundBalance: 154954.81338820115,
              },
              {
                period: 217,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 605.7105058075836,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5925.236239605734,
                fundBalance: 149053.5571210883,
              },
              {
                period: 218,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 581.6330088279248,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5949.313736585393,
                fundBalance: 143128.32088148256,
              },
              {
                period: 219,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 557.4575904016417,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5973.489155011676,
                fundBalance: 137179.0071448972,
              },
              {
                period: 220,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 533.183851951716,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 5997.762893461601,
                fundBalance: 131205.51798988553,
              },
              {
                period: 221,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 508.8113932773708,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6022.135352135947,
                fundBalance: 125207.7550964239,
              },
              {
                period: 222,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 484.3398125474504,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6046.606932865867,
                fundBalance: 119185.61974428795,
              },
              {
                period: 223,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 459.7687062937719,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6071.178039119546,
                fundBalance: 113139.01281142207,
              },
              {
                period: 224,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 435.0976694044505,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6095.849076008867,
                fundBalance: 107067.83477230254,
              },
              {
                period: 225,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 410.3262951171975,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6120.620450296119,
                fundBalance: 100971.98569629366,
              },
              {
                period: 226,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 385.4541750125903,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6145.492570400727,
                fundBalance: 94851.36524599754,
              },
              {
                period: 227,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 360.4808990073158,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6170.465846406002,
                fundBalance: 88705.87267559681,
              },
              {
                period: 228,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 335.4060553473855,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6195.540690065932,
                fundBalance: 82535.4068291908,
              },
              {
                period: 229,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 310.22923060132325,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6220.717514811995,
                fundBalance: 76339.86613912488,
              },
              {
                period: 230,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 284.9500096533253,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6245.996735759993,
                fundBalance: 70119.14862431289,
              },
              {
                period: 231,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 259.56797569639207,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6271.378769716925,
                fundBalance: 63873.151888552886,
              },
              {
                period: 232,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 234.08271022543255,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6296.864035187886,
                fundBalance: 57601.77311883596,
              },
              {
                period: 233,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 208.49379303033945,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6322.452952382978,
                fundBalance: 51304.909083648075,
              },
              {
                period: 234,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 182.80080218903734,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6348.145943224281,
                fundBalance: 44982.4561312651,
              },
              {
                period: 235,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 157.00331406050157,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6373.943431352816,
                fundBalance: 38634.31018804082,
              },
              {
                period: 236,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 131.10090327774898,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6399.845842135569,
                fundBalance: 32260.366756688003,
              },
              {
                period: 237,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 105.09314274079998,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6425.853602672518,
                fundBalance: 25860.52091455243,
              },
              {
                period: 238,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 78.97960360961201,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6451.967141803705,
                fundBalance: 19434.667311879915,
              },
              {
                period: 239,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 52.759855296983936,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6478.186890116333,
                fundBalance: 12982.700170076208,
              },
              {
                period: 240,
                totalMonthlyReturn: 6530.946745413317,
                monthlyInterestReturn: 26.433465461431663,
                additionalAmountDueToAdditionalFee: 0,
                monthlyFundReturn: 6504.513279951886,
                fundBalance: 6504.513279959876,
              },
            ],
            maxMonthlyReturn: 6530.946745413317,
            minMonthlyReturn: 6530.946745413317,
            totalReturn: 1567427.218899199,
            totalInterestReturn: 567427.2188992042,
            returnConversion: 1.5674272188991991,
          },
          {
            risk: 2,
            totalAdditionalAmountDueToAdditionalFee: 315508.3224379995,
            disposalBoard: [
              {
                period: 1,
                totalMonthlyReturn: 5810.787661318866,
                monthlyInterestReturn: 2905.875,
                additionalAmountDueToAdditionalFee: 8.850386444144533,
                monthlyFundReturn: 2904.9126613188664,
                fundBalance: 1001625,
              },
              {
                period: 2,
                totalMonthlyReturn: 5819.660173729122,
                monthlyInterestReturn: 2901.462088301932,
                additionalAmountDueToAdditionalFee: 17.722898854399546,
                monthlyFundReturn: 2918.1980854271897,
                fundBalance: 1000344.0784721042,
              },
              {
                period: 3,
                totalMonthlyReturn: 5828.554867420402,
                monthlyInterestReturn: 2897.0101230691903,
                additionalAmountDueToAdditionalFee: 26.61759254568028,
                monthlyFundReturn: 2931.544744351212,
                fundBalance: 999048.8355901685,
              },
              {
                period: 4,
                totalMonthlyReturn: 5837.47179784591,
                monthlyInterestReturn: 2892.5188755244444,
                additionalAmountDueToAdditionalFee: 35.53452297118906,
                monthlyFundReturn: 2944.9529223214668,
                fundBalance: 997739.1828696055,
              },
              {
                period: 5,
                totalMonthlyReturn: 5846.411020597484,
                monthlyInterestReturn: 2887.988115701437,
                additionalAmountDueToAdditionalFee: 44.473745722761805,
                monthlyFundReturn: 2958.422904896047,
                fundBalance: 996415.0313541392,
              },
              {
                period: 6,
                totalMonthlyReturn: 5855.372591405935,
                monthlyInterestReturn: 2883.4176124390915,
                additionalAmountDueToAdditionalFee: 53.4353165312134,
                monthlyFundReturn: 2971.9549789668436,
                fundBalance: 995076.2916134312,
              },
              {
                period: 7,
                totalMonthlyReturn: 5864.356566141408,
                monthlyInterestReturn: 2878.807133375595,
                additionalAmountDueToAdditionalFee: 62.41929126668606,
                monthlyFundReturn: 2985.5494327658125,
                fundBalance: 993722.8737406956,
              },
              {
                period: 8,
                totalMonthlyReturn: 5873.363000813719,
                monthlyInterestReturn: 2874.156444942456,
                additionalAmountDueToAdditionalFee: 71.4257259389974,
                monthlyFundReturn: 2999.2065558712634,
                fundBalance: 992354.6873503021,
              },
              {
                period: 9,
                totalMonthlyReturn: 5882.391951572711,
                monthlyInterestReturn: 2869.4653123585276,
                additionalAmountDueToAdditionalFee: 80.4546766979895,
                monthlyFundReturn: 3012.926639214184,
                fundBalance: 990971.6415753667,
              },
              {
                period: 10,
                totalMonthlyReturn: 5891.443474708601,
                monthlyInterestReturn: 2864.7334996240033,
                additionalAmountDueToAdditionalFee: 89.50619983387901,
                monthlyFundReturn: 3026.7099750845973,
                fundBalance: 989573.6450653314,
              },
              {
                period: 11,
                totalMonthlyReturn: 5900.51762665233,
                monthlyInterestReturn: 2859.960769514389,
                additionalAmountDueToAdditionalFee: 98.58035177760826,
                monthlyFundReturn: 3040.5568571379413,
                fundBalance: 988160.6059835323,
              },
              {
                period: 12,
                totalMonthlyReturn: 5909.614463975919,
                monthlyInterestReturn: 2855.1468835744363,
                additionalAmountDueToAdditionalFee: 107.67718910119697,
                monthlyFundReturn: 3054.467580401483,
                fundBalance: 986732.4320047538,
              },
              {
                period: 13,
                totalMonthlyReturn: 5918.734043392817,
                monthlyInterestReturn: 2850.291602112055,
                additionalAmountDueToAdditionalFee: 116.7967685180945,
                monthlyFundReturn: 3068.4424412807616,
                fundBalance: 985289.0303127738,
              },
              {
                period: 14,
                totalMonthlyReturn: 5927.876421758256,
                monthlyInterestReturn: 2845.3946841921907,
                additionalAmountDueToAdditionalFee: 125.93914688353425,
                monthlyFundReturn: 3082.481737566065,
                fundBalance: 983830.3075978941,
              },
              {
                period: 15,
                totalMonthlyReturn: 5937.041656069609,
                monthlyInterestReturn: 2840.4558876306764,
                additionalAmountDueToAdditionalFee: 135.10438119488754,
                monthlyFundReturn: 3096.585768438933,
                fundBalance: 982356.1700544604,
              },
              {
                period: 16,
                totalMonthlyReturn: 5946.229803466741,
                monthlyInterestReturn: 2835.47496898805,
                additionalAmountDueToAdditionalFee: 144.29252859201938,
                monthlyFundReturn: 3110.7548344786915,
                fundBalance: 980866.5233783696,
              },
              {
                period: 17,
                totalMonthlyReturn: 5955.440921232366,
                monthlyInterestReturn: 2830.4516835633463,
                additionalAmountDueToAdditionalFee: 153.50364635764413,
                monthlyFundReturn: 3124.98923766902,
                fundBalance: 979361.2727645645,
              },
              {
                period: 18,
                totalMonthlyReturn: 5964.675066792404,
                monthlyInterestReturn: 2825.3857853878567,
                additionalAmountDueToAdditionalFee: 162.7377919176829,
                monthlyFundReturn: 3139.289281404548,
                fundBalance: 977840.3229045167,
              },
              {
                period: 19,
                totalMonthlyReturn: 5973.932297716344,
                monthlyInterestReturn: 2820.2770272188573,
                additionalAmountDueToAdditionalFee: 171.99502284162168,
                monthlyFundReturn: 3153.6552704974856,
                fundBalance: 976303.5779836976,
              },
              {
                period: 20,
                totalMonthlyReturn: 5983.2126717175925,
                monthlyInterestReturn: 2815.1251605333123,
                additionalAmountDueToAdditionalFee: 181.27539684287035,
                monthlyFundReturn: 3168.08751118428,
                fundBalance: 974750.9416790361,
              },
              {
                period: 21,
                totalMonthlyReturn: 5992.516246653844,
                monthlyInterestReturn: 2809.9299355215353,
                additionalAmountDueToAdditionalFee: 190.57897177912196,
                monthlyFundReturn: 3182.5863111323088,
                fundBalance: 973182.3171563637,
              },
              {
                period: 22,
                totalMonthlyReturn: 6001.8430805274365,
                monthlyInterestReturn: 2804.691101080837,
                additionalAmountDueToAdditionalFee: 199.90580565271443,
                monthlyFundReturn: 3197.1519794465994,
                fundBalance: 971597.6070678482,
              },
              {
                period: 23,
                totalMonthlyReturn: 6011.193231485713,
                monthlyInterestReturn: 2799.408404809123,
                additionalAmountDueToAdditionalFee: 209.255956610991,
                monthlyFundReturn: 3211.7848266765895,
                fundBalance: 969996.7135494142,
              },
              {
                period: 24,
                totalMonthlyReturn: 6020.566757821385,
                monthlyInterestReturn: 2794.0815929984783,
                additionalAmountDueToAdditionalFee: 218.62948294666307,
                monthlyFundReturn: 3226.485164822907,
                fundBalance: 968379.5382181501,
              },
              {
                period: 25,
                totalMonthlyReturn: 6029.963717972896,
                monthlyInterestReturn: 2788.710410628705,
                additionalAmountDueToAdditionalFee: 228.02644309817424,
                monthlyFundReturn: 3241.2533073441905,
                fundBalance: 966745.9821697052,
              },
              {
                period: 26,
                totalMonthlyReturn: 6039.384170524787,
                monthlyInterestReturn: 2783.2946013608434,
                additionalAmountDueToAdditionalFee: 237.44689565006433,
                monthlyFundReturn: 3256.0895691639435,
                fundBalance: 965095.9459756692,
              },
              {
                period: 27,
                totalMonthlyReturn: 6048.828174208056,
                monthlyInterestReturn: 2777.833907530647,
                additionalAmountDueToAdditionalFee: 246.89089933333412,
                monthlyFundReturn: 3270.994266677409,
                fundBalance: 963429.3296809444,
              },
              {
                period: 28,
                totalMonthlyReturn: 6058.2957879005335,
                monthlyInterestReturn: 2772.328070142041,
                additionalAmountDueToAdditionalFee: 256.35851302581204,
                monthlyFundReturn: 3285.967717758493,
                fundBalance: 961746.032801101,
              },
              {
                period: 29,
                totalMonthlyReturn: 6067.787070627242,
                monthlyInterestReturn: 2766.7768288605334,
                additionalAmountDueToAdditionalFee: 265.84979575252123,
                monthlyFundReturn: 3301.0102417667094,
                fundBalance: 960045.9543197206,
              },
              {
                period: 30,
                totalMonthlyReturn: 6077.302081560769,
                monthlyInterestReturn: 2761.179922006611,
                additionalAmountDueToAdditionalFee: 275.36480668604713,
                monthlyFundReturn: 3316.122159554158,
                fundBalance: 958328.9926857285,
              },
              {
                period: 31,
                totalMonthlyReturn: 6086.840880021628,
                monthlyInterestReturn: 2755.537086549087,
                additionalAmountDueToAdditionalFee: 284.9036051469068,
                monthlyFundReturn: 3331.3037934725417,
                fundBalance: 956595.045810709,
              },
              {
                period: 32,
                totalMonthlyReturn: 6096.40352547864,
                monthlyInterestReturn: 2749.848058098427,
                additionalAmountDueToAdditionalFee: 294.46625060391875,
                monthlyFundReturn: 3346.555467380214,
                fundBalance: 954844.0110662119,
              },
              {
                period: 33,
                totalMonthlyReturn: 6105.990077549295,
                monthlyInterestReturn: 2744.112570900041,
                additionalAmountDueToAdditionalFee: 304.0528026745733,
                monthlyFundReturn: 3361.877506649254,
                fundBalance: 953075.7852810426,
              },
              {
                period: 34,
                totalMonthlyReturn: 6115.600596000126,
                monthlyInterestReturn: 2738.33035782754,
                additionalAmountDueToAdditionalFee: 313.6633211254043,
                monthlyFundReturn: 3377.270238172586,
                fundBalance: 951290.2647385406,
              },
              {
                period: 35,
                totalMonthlyReturn: 6125.235140747084,
                monthlyInterestReturn: 2732.501150375961,
                additionalAmountDueToAdditionalFee: 323.2978658723623,
                monthlyFundReturn: 3392.733990371123,
                fundBalance: 949487.3451738441,
              },
              {
                period: 36,
                totalMonthlyReturn: 6134.89377185591,
                monthlyInterestReturn: 2726.6246786549614,
                additionalAmountDueToAdditionalFee: 332.9564969811879,
                monthlyFundReturn: 3408.269093200948,
                fundBalance: 947666.9217711409,
              },
              {
                period: 37,
                totalMonthlyReturn: 6144.576549542507,
                monthlyInterestReturn: 2720.7006713819774,
                additionalAmountDueToAdditionalFee: 342.63927466778546,
                monthlyFundReturn: 3423.8758781605293,
                fundBalance: 945828.8891609067,
              },
              {
                period: 38,
                totalMonthlyReturn: 6154.283534173322,
                monthlyInterestReturn: 2714.728855875351,
                additionalAmountDueToAdditionalFee: 352.34625929859953,
                monthlyFundReturn: 3439.55467829797,
                fundBalance: 943973.1414171293,
              },
              {
                period: 39,
                totalMonthlyReturn: 6164.014786265712,
                monthlyInterestReturn: 2708.7089580474235,
                additionalAmountDueToAdditionalFee: 362.0775113909906,
                monthlyFundReturn: 3455.305828218289,
                fundBalance: 942099.5720545191,
              },
              {
                period: 40,
                totalMonthlyReturn: 6173.770366488335,
                monthlyInterestReturn: 2702.640702397594,
                additionalAmountDueToAdditionalFee: 371.8330916136126,
                monthlyFundReturn: 3471.1296640907403,
                fundBalance: 940208.0740257059,
              },
              {
                period: 41,
                totalMonthlyReturn: 6183.550335661514,
                monthlyInterestReturn: 2696.523812005349,
                additionalAmountDueToAdditionalFee: 381.6130607867915,
                monthlyFundReturn: 3487.0265236561645,
                fundBalance: 938298.5397184233,
              },
              {
                period: 42,
                totalMonthlyReturn: 6193.3547547576245,
                monthlyInterestReturn: 2690.358008523251,
                additionalAmountDueToAdditionalFee: 391.41747988290285,
                monthlyFundReturn: 3502.9967462343734,
                fundBalance: 936370.8609526765,
              },
              {
                period: 43,
                totalMonthlyReturn: 6203.183684901477,
                monthlyInterestReturn: 2684.1430121698995,
                additionalAmountDueToAdditionalFee: 401.24641002675503,
                monthlyFundReturn: 3519.040672731577,
                fundBalance: 934424.9289778995,
              },
              {
                period: 44,
                totalMonthlyReturn: 6213.037187370689,
                monthlyInterestReturn: 2677.8785417228546,
                additionalAmountDueToAdditionalFee: 411.09991249596646,
                monthlyFundReturn: 3535.1586456478335,
                fundBalance: 932460.6344700961,
              },
              {
                period: 45,
                totalMonthlyReturn: 6222.915323596073,
                monthlyInterestReturn: 2671.5643145115273,
                additionalAmountDueToAdditionalFee: 420.9780487213511,
                monthlyFundReturn: 3551.3510090845457,
                fundBalance: 930477.8675289673,
              },
              {
                period: 46,
                totalMonthlyReturn: 6232.81815516202,
                monthlyInterestReturn: 2665.2000464100347,
                additionalAmountDueToAdditionalFee: 430.8808802872991,
                monthlyFundReturn: 3567.6181087519863,
                fundBalance: 928476.5176750262,
              },
              {
                period: 47,
                totalMonthlyReturn: 6242.745743806884,
                monthlyInterestReturn: 2658.7854518300223,
                additionalAmountDueToAdditionalFee: 440.80846893216176,
                monthlyFundReturn: 3583.9602919768613,
                fundBalance: 926456.4738466959,
              },
              {
                period: 48,
                totalMonthlyReturn: 6252.698151423359,
                monthlyInterestReturn: 2652.3202437134505,
                additionalAmountDueToAdditionalFee: 450.76087654863704,
                monthlyFundReturn: 3600.3779077099084,
                fundBalance: 924417.6243973963,
              },
              {
                period: 49,
                totalMonthlyReturn: 6262.675440058875,
                monthlyInterestReturn: 2645.804133525344,
                additionalAmountDueToAdditionalFee: 460.7381651841531,
                monthlyFundReturn: 3616.871306533531,
                fundBalance: 922359.8570926144,
              },
              {
                period: 50,
                totalMonthlyReturn: 6272.677671915981,
                monthlyInterestReturn: 2639.2368312465105,
                additionalAmountDueToAdditionalFee: 470.74039704125835,
                monthlyFundReturn: 3633.4408406694697,
                fundBalance: 920283.059106961,
              },
              {
                period: 51,
                totalMonthlyReturn: 6282.7049093527285,
                monthlyInterestReturn: 2632.618045366222,
                additionalAmountDueToAdditionalFee: 480.7676344780059,
                monthlyFundReturn: 3650.0868639865066,
                fundBalance: 918187.1170212135,
              },
              {
                period: 52,
                totalMonthlyReturn: 6292.757214883068,
                monthlyInterestReturn: 2625.947482874857,
                additionalAmountDueToAdditionalFee: 490.8199400083456,
                monthlyFundReturn: 3666.8097320082106,
                fundBalance: 916071.9168193436,
              },
              {
                period: 53,
                totalMonthlyReturn: 6302.834651177232,
                monthlyInterestReturn: 2619.224849256516,
                additionalAmountDueToAdditionalFee: 500.89737630251125,
                monthlyFundReturn: 3683.609801920717,
                fundBalance: 913937.3438855303,
              },
              {
                period: 54,
                totalMonthlyReturn: 6312.9372810621335,
                monthlyInterestReturn: 2612.4498484815913,
                additionalAmountDueToAdditionalFee: 511.0000061874123,
                monthlyFundReturn: 3700.487432580542,
                fundBalance: 911783.2830011586,
              },
              {
                period: 55,
                totalMonthlyReturn: 6323.065167521748,
                monthlyInterestReturn: 2605.6221829993083,
                additionalAmountDueToAdditionalFee: 521.1278926470254,
                monthlyFundReturn: 3717.442984522439,
                fundBalance: 909609.6183418045,
              },
              {
                period: 56,
                totalMonthlyReturn: 6333.218373697509,
                monthlyInterestReturn: 2598.7415537302254,
                additionalAmountDueToAdditionalFee: 531.2810988227875,
                monthlyFundReturn: 3734.476819967284,
                fundBalance: 907416.2334742027,
              },
              {
                period: 57,
                totalMonthlyReturn: 6343.39696288871,
                monthlyInterestReturn: 2591.807660058703,
                additionalAmountDueToAdditionalFee: 541.4596880139889,
                monthlyFundReturn: 3751.589302830008,
                fundBalance: 905203.0113532024,
              },
              {
                period: 58,
                totalMonthlyReturn: 6353.60099855289,
                monthlyInterestReturn: 2584.820199825329,
                additionalAmountDueToAdditionalFee: 551.6637236781683,
                monthlyFundReturn: 3768.780798727561,
                fundBalance: 902969.8343187058,
              },
              {
                period: 59,
                totalMonthlyReturn: 6363.83054430623,
                monthlyInterestReturn: 2577.7788693193165,
                additionalAmountDueToAdditionalFee: 561.8932694315085,
                monthlyFundReturn: 3786.051674986914,
                fundBalance: 900716.5840925938,
              },
              {
                period: 60,
                totalMonthlyReturn: 6374.085663923954,
                monthlyInterestReturn: 2570.683363270855,
                additionalAmountDueToAdditionalFee: 572.1483890492318,
                monthlyFundReturn: 3803.402300653099,
                fundBalance: 898443.1417756338,
              },
              {
                period: 61,
                totalMonthlyReturn: 6384.366421340722,
                monthlyInterestReturn: 2563.533374843434,
                additionalAmountDueToAdditionalFee: 582.4291464659996,
                monthlyFundReturn: 3820.8330464972873,
                fundBalance: 896149.387844376,
              },
              {
                period: 62,
                totalMonthlyReturn: 6394.672880651031,
                monthlyInterestReturn: 2556.328595626123,
                additionalAmountDueToAdditionalFee: 592.7356057763091,
                monthlyFundReturn: 3838.3442850249075,
                fundBalance: 893835.2021480312,
              },
              {
                period: 63,
                totalMonthlyReturn: 6405.0051061096165,
                monthlyInterestReturn: 2549.068715625814,
                additionalAmountDueToAdditionalFee: 603.0678312348941,
                monthlyFundReturn: 3855.9363904838015,
                fundBalance: 891500.4639053356,
              },
              {
                period: 64,
                totalMonthlyReturn: 6415.363162131848,
                monthlyInterestReturn: 2541.753423259433,
                additionalAmountDueToAdditionalFee: 613.4258872571261,
                monthlyFundReturn: 3873.609738872415,
                fundBalance: 889145.0517013987,
              },
              {
                period: 65,
                totalMonthlyReturn: 6425.747113294135,
                monthlyInterestReturn: 2534.3824053461044,
                additionalAmountDueToAdditionalFee: 623.8098384194134,
                monthlyFundReturn: 3891.3647079480306,
                fundBalance: 886768.843484537,
              },
              {
                period: 66,
                totalMonthlyReturn: 6436.1570243343285,
                monthlyInterestReturn: 2526.955347099288,
                additionalAmountDueToAdditionalFee: 634.2197494596066,
                monthlyFundReturn: 3909.2016772350407,
                fundBalance: 884371.7165630913,
              },
              {
                period: 67,
                totalMonthlyReturn: 6446.592960152121,
                monthlyInterestReturn: 2519.471932118867,
                additionalAmountDueToAdditionalFee: 644.6556852773999,
                monthlyFundReturn: 3927.1210280332552,
                fundBalance: 881953.5476022293,
              },
              {
                period: 68,
                totalMonthlyReturn: 6457.05498580946,
                monthlyInterestReturn: 2511.931842383206,
                additionalAmountDueToAdditionalFee: 655.1177109347379,
                monthlyFundReturn: 3945.1231434262536,
                fundBalance: 879514.2126207317,
              },
              {
                period: 69,
                totalMonthlyReturn: 6467.543166530942,
                monthlyInterestReturn: 2504.3347582411693,
                additionalAmountDueToAdditionalFee: 665.6058916562195,
                monthlyFundReturn: 3963.208408289772,
                fundBalance: 877053.5869877632,
              },
              {
                period: 70,
                totalMonthlyReturn: 6478.057567704226,
                monthlyInterestReturn: 2496.680358404095,
                additionalAmountDueToAdditionalFee: 676.1202928295045,
                monthlyFundReturn: 3981.3772093001317,
                fundBalance: 874571.5454196272,
              },
              {
                period: 71,
                totalMonthlyReturn: 6488.598254880444,
                monthlyInterestReturn: 2488.9683199377378,
                additionalAmountDueToAdditionalFee: 686.6609800057231,
                monthlyFundReturn: 3999.629934942707,
                fundBalance: 872067.9619765054,
              },
              {
                period: 72,
                totalMonthlyReturn: 6499.165293774604,
                monthlyInterestReturn: 2481.198318254167,
                additionalAmountDueToAdditionalFee: 697.228018899882,
                monthlyFundReturn: 4017.966975520437,
                fundBalance: 869542.7100591804,
              },
              {
                period: 73,
                totalMonthlyReturn: 6509.758750265998,
                monthlyInterestReturn: 2473.3700271036287,
                additionalAmountDueToAdditionalFee: 707.8214753912762,
                monthlyFundReturn: 4036.3887231623694,
                fundBalance: 866995.662405743,
              },
              {
                period: 74,
                totalMonthlyReturn: 6520.378690398621,
                monthlyInterestReturn: 2465.483118566368,
                additionalAmountDueToAdditionalFee: 718.441415523899,
                monthlyFundReturn: 4054.8955718322527,
                fundBalance: 864426.6910882839,
              },
              {
                period: 75,
                totalMonthlyReturn: 6531.0251803815745,
                monthlyInterestReturn: 2457.53726304441,
                additionalAmountDueToAdditionalFee: 729.0879055068533,
                monthlyFundReturn: 4073.487917337165,
                fundBalance: 861835.6675095677,
              },
              {
                period: 76,
                totalMonthlyReturn: 6541.698286589488,
                monthlyInterestReturn: 2449.5321292533026,
                additionalAmountDueToAdditionalFee: 739.7610117147651,
                monthlyFundReturn: 4092.1661573361844,
                fundBalance: 859222.4623996919,
              },
              {
                period: 77,
                totalMonthlyReturn: 6552.398075562919,
                monthlyInterestReturn: 2441.467384213822,
                additionalAmountDueToAdditionalFee: 750.4608006881967,
                monthlyFundReturn: 4110.930691349096,
                fundBalance: 856586.9458127297,
              },
              {
                period: 78,
                totalMonthlyReturn: 6563.124614008784,
                monthlyInterestReturn: 2433.3426932436287,
                additionalAmountDueToAdditionalFee: 761.1873391340619,
                monthlyFundReturn: 4129.7819207651555,
                fundBalance: 853928.9871233546,
              },
              {
                period: 79,
                totalMonthlyReturn: 6573.8779688007635,
                monthlyInterestReturn: 2425.1577199488956,
                additionalAmountDueToAdditionalFee: 771.9406939260416,
                monthlyFundReturn: 4148.720248851868,
                fundBalance: 851248.455023451,
              },
              {
                period: 80,
                totalMonthlyReturn: 6584.658206979723,
                monthlyInterestReturn: 2416.9121262158874,
                additionalAmountDueToAdditionalFee: 782.7209321050013,
                monthlyFundReturn: 4167.746080763836,
                fundBalance: 848545.2175187065,
              },
              {
                period: 81,
                totalMonthlyReturn: 6595.46539575413,
                monthlyInterestReturn: 2408.6055722025003,
                additionalAmountDueToAdditionalFee: 793.5281208794081,
                monthlyFundReturn: 4186.859823551629,
                fundBalance: 845819.1419251881,
              },
              {
                period: 82,
                totalMonthlyReturn: 6606.299602500472,
                monthlyInterestReturn: 2400.237716329764,
                additionalAmountDueToAdditionalFee: 804.3623276257513,
                monthlyFundReturn: 4206.061886170709,
                fundBalance: 843070.0948659017,
              },
              {
                period: 83,
                totalMonthlyReturn: 6617.160894763681,
                monthlyInterestReturn: 2391.8082152733,
                additionalAmountDueToAdditionalFee: 815.22361988896,
                monthlyFundReturn: 4225.352679490382,
                fundBalance: 840297.942267335,
              },
              {
                period: 84,
                totalMonthlyReturn: 6628.0493402575485,
                monthlyInterestReturn: 2383.316723954737,
                additionalAmountDueToAdditionalFee: 826.112065382827,
                monthlyFundReturn: 4244.732616302812,
                fundBalance: 837502.5493559821,
              },
              {
                period: 85,
                totalMonthlyReturn: 6638.96500686515,
                monthlyInterestReturn: 2374.762895533091,
                additionalAmountDueToAdditionalFee: 837.0277319904285,
                monthlyFundReturn: 4264.202111332059,
                fundBalance: 834683.7806548541,
              },
              {
                period: 86,
                totalMonthlyReturn: 6649.90796263927,
                monthlyInterestReturn: 2366.146381396096,
                additionalAmountDueToAdditionalFee: 847.970687764549,
                monthlyFundReturn: 4283.761581243174,
                fundBalance: 831841.4999799686,
              },
              {
                period: 87,
                totalMonthlyReturn: 6660.8782758028265,
                monthlyInterestReturn: 2357.466831151498,
                additionalAmountDueToAdditionalFee: 858.941000928105,
                monthlyFundReturn: 4303.411444651329,
                fundBalance: 828975.5704368266,
              },
              {
                period: 88,
                totalMonthlyReturn: 6671.876014749292,
                monthlyInterestReturn: 2348.7238926183063,
                additionalAmountDueToAdditionalFee: 869.9387398745698,
                monthlyFundReturn: 4323.152122130985,
                fundBalance: 826085.8544168675,
              },
              {
                period: 89,
                totalMonthlyReturn: 6682.901248043123,
                monthlyInterestReturn: 2339.917211818,
                additionalAmountDueToAdditionalFee: 880.9639731684006,
                monthlyFundReturn: 4342.9840362251225,
                fundBalance: 823172.213593911,
              },
              {
                period: 90,
                totalMonthlyReturn: 6693.954044420188,
                monthlyInterestReturn: 2331.046432965694,
                additionalAmountDueToAdditionalFee: 892.0167695454661,
                monthlyFundReturn: 4362.907611454494,
                fundBalance: 820234.5089205784,
              },
              {
                period: 91,
                totalMonthlyReturn: 6705.034472788197,
                monthlyInterestReturn: 2322.1111984612617,
                additionalAmountDueToAdditionalFee: 903.0971979134742,
                monthlyFundReturn: 4382.923274326935,
                fundBalance: 817272.6006246988,
              },
              {
                period: 92,
                totalMonthlyReturn: 6716.142602227124,
                monthlyInterestReturn: 2313.1111488804167,
                additionalAmountDueToAdditionalFee: 914.2053273524025,
                monthlyFundReturn: 4403.031453346708,
                fundBalance: 814286.3482056956,
              },
              {
                period: 93,
                totalMonthlyReturn: 6727.27850198965,
                monthlyInterestReturn: 2304.045922965747,
                additionalAmountDueToAdditionalFee: 925.3412271149282,
                monthlyFundReturn: 4423.232579023903,
                fundBalance: 811275.6104309577,
              },
              {
                period: 94,
                totalMonthlyReturn: 6738.4422415015815,
                monthlyInterestReturn: 2294.915157617711,
                additionalAmountDueToAdditionalFee: 936.5049666268601,
                monthlyFundReturn: 4443.5270838838715,
                fundBalance: 808240.2453321905,
              },
              {
                period: 95,
                totalMonthlyReturn: 6749.633890362294,
                monthlyInterestReturn: 2285.718487885584,
                additionalAmountDueToAdditionalFee: 947.6966154875718,
                monthlyFundReturn: 4463.9154024767095,
                fundBalance: 805180.1102017506,
              },
              {
                period: 96,
                totalMonthlyReturn: 6760.853518345157,
                monthlyInterestReturn: 2276.4555469583693,
                additionalAmountDueToAdditionalFee: 958.9162434704353,
                monthlyFundReturn: 4484.3979713867875,
                fundBalance: 802095.061588963,
              },
              {
                period: 97,
                totalMonthlyReturn: 6772.101195397978,
                monthlyInterestReturn: 2267.1259661556574,
                additionalAmountDueToAdditionalFee: 970.1639205232559,
                monthlyFundReturn: 4504.97522924232,
                fundBalance: 798984.9552964192,
              },
              {
                period: 98,
                totalMonthlyReturn: 6783.376991643431,
                monthlyInterestReturn: 2257.7293749184437,
                additionalAmountDueToAdditionalFee: 981.4397167687089,
                monthlyFundReturn: 4525.6476167249875,
                fundBalance: 795849.6463762567,
              },
              {
                period: 99,
                totalMonthlyReturn: 6794.680977379498,
                monthlyInterestReturn: 2248.2654007999035,
                additionalAmountDueToAdditionalFee: 992.7437025047752,
                monthlyFundReturn: 4546.415576579593,
                fundBalance: 792688.9891264231,
              },
              {
                period: 100,
                totalMonthlyReturn: 6806.0132230799045,
                monthlyInterestReturn: 2238.7336694561213,
                additionalAmountDueToAdditionalFee: 1004.0759482051817,
                monthlyFundReturn: 4567.279553623783,
                fundBalance: 789502.8370869181,
              },
              {
                period: 101,
                totalMonthlyReturn: 6817.3737993945615,
                monthlyInterestReturn: 2229.1338046367755,
                additionalAmountDueToAdditionalFee: 1015.4365245198392,
                monthlyFundReturn: 4588.239994757786,
                fundBalance: 786291.0430360207,
              },
              {
                period: 102,
                totalMonthlyReturn: 6828.762777150005,
                monthlyInterestReturn: 2219.465428175775,
                additionalAmountDueToAdditionalFee: 1026.8255022752833,
                monthlyFundReturn: 4609.29734897423,
                fundBalance: 783053.4589864959,
              },
              {
                period: 103,
                totalMonthlyReturn: 6840.180227349838,
                monthlyInterestReturn: 2209.728159981858,
                additionalAmountDueToAdditionalFee: 1038.242952475116,
                monthlyFundReturn: 4630.45206736798,
                fundBalance: 779789.936181783,
              },
              {
                period: 104,
                totalMonthlyReturn: 6851.62622117517,
                monthlyInterestReturn: 2199.921618029136,
                additionalAmountDueToAdditionalFee: 1049.6889463004482,
                monthlyFundReturn: 4651.704603146034,
                fundBalance: 776500.3250921665,
              },
              {
                period: 105,
                totalMonthlyReturn: 6863.1008299850655,
                monthlyInterestReturn: 2190.0454183475995,
                additionalAmountDueToAdditionalFee: 1061.163555110344,
                monthlyFundReturn: 4673.055411637467,
                fundBalance: 773184.475410927,
              },
              {
                period: 106,
                totalMonthlyReturn: 6874.604125316986,
                monthlyInterestReturn: 2180.0991750135754,
                additionalAmountDueToAdditionalFee: 1072.6668504422641,
                monthlyFundReturn: 4694.504950303411,
                fundBalance: 769842.2360504736,
              },
              {
                period: 107,
                totalMonthlyReturn: 6886.136178887236,
                monthlyInterestReturn: 2170.0825001401367,
                additionalAmountDueToAdditionalFee: 1084.1989040125145,
                monthlyFundReturn: 4716.053678747099,
                fundBalance: 766473.4551384585,
              },
              {
                period: 108,
                totalMonthlyReturn: 6897.697062591413,
                monthlyInterestReturn: 2159.9950038674665,
                additionalAmountDueToAdditionalFee: 1095.7597877166904,
                monthlyFundReturn: 4737.702058723946,
                fundBalance: 763077.9800138708,
              },
              {
                period: 109,
                totalMonthlyReturn: 6909.286848504849,
                monthlyInterestReturn: 2149.8362943531793,
                additionalAmountDueToAdditionalFee: 1107.349573630127,
                monthlyFundReturn: 4759.45055415167,
                fundBalance: 759655.6572231128,
              },
              {
                period: 110,
                totalMonthlyReturn: 6920.905608883068,
                monthlyInterestReturn: 2139.605977762588,
                additionalAmountDueToAdditionalFee: 1118.968334008347,
                monthlyFundReturn: 4781.299631120481,
                fundBalance: 756206.3325160564,
              },
              {
                period: 111,
                totalMonthlyReturn: 6932.553416162234,
                monthlyInterestReturn: 2129.303658258933,
                additionalAmountDueToAdditionalFee: 1130.6161412875122,
                monthlyFundReturn: 4803.2497579033015,
                fundBalance: 752729.8508420804,
              },
              {
                period: 112,
                totalMonthlyReturn: 6944.230342959597,
                monthlyInterestReturn: 2118.9289379935553,
                additionalAmountDueToAdditionalFee: 1142.2930680848754,
                monthlyFundReturn: 4825.301404966041,
                fundBalance: 749226.0563460884,
              },
              {
                period: 113,
                totalMonthlyReturn: 6955.936462073954,
                monthlyInterestReturn: 2108.481417096029,
                additionalAmountDueToAdditionalFee: 1153.9991871992324,
                monthlyFundReturn: 4847.455044977925,
                fundBalance: 745694.7923645077,
              },
              {
                period: 114,
                totalMonthlyReturn: 6967.671846486097,
                monthlyInterestReturn: 2097.960693664241,
                additionalAmountDueToAdditionalFee: 1165.734571611375,
                monthlyFundReturn: 4869.711152821856,
                fundBalance: 742135.9014212678,
              },
              {
                period: 115,
                totalMonthlyReturn: 6979.43656935927,
                monthlyInterestReturn: 2087.366363754427,
                additionalAmountDueToAdditionalFee: 1177.499294484548,
                monthlyFundReturn: 4892.070205604843,
                fundBalance: 738549.2252237594,
              },
              {
                period: 116,
                totalMonthlyReturn: 6991.230704039626,
                monthlyInterestReturn: 2076.6980213711577,
                additionalAmountDueToAdditionalFee: 1189.293429164904,
                monthlyFundReturn: 4914.532682668469,
                fundBalance: 734934.604658776,
              },
              {
                period: 117,
                totalMonthlyReturn: 7003.054324056683,
                monthlyInterestReturn: 2065.955258457274,
                additionalAmountDueToAdditionalFee: 1201.1170491819607,
                monthlyFundReturn: 4937.099065599408,
                fundBalance: 731291.8797884309,
              },
              {
                period: 118,
                totalMonthlyReturn: 7014.907503123783,
                monthlyInterestReturn: 2055.1376648837777,
                additionalAmountDueToAdditionalFee: 1212.9702282490603,
                monthlyFundReturn: 4959.769838240005,
                fundBalance: 727620.8898460595,
              },
              {
                period: 119,
                totalMonthlyReturn: 7026.790315138549,
                monthlyInterestReturn: 2044.244828439672,
                additionalAmountDueToAdditionalFee: 1224.853040263827,
                monthlyFundReturn: 4982.545486698877,
                fundBalance: 723921.4732320984,
              },
              {
                period: 120,
                totalMonthlyReturn: 7038.702834183353,
                monthlyInterestReturn: 2033.2763348217522,
                additionalAmountDueToAdditionalFee: 1236.765559308631,
                monthlyFundReturn: 5005.426499361601,
                fundBalance: 720193.4675099447,
              },
              {
                period: 121,
                totalMonthlyReturn: 7050.645134525768,
                monthlyInterestReturn: 2022.231767624347,
                additionalAmountDueToAdditionalFee: 1248.7078596510473,
                monthlyFundReturn: 5028.413366901423,
                fundBalance: 716436.7094017965,
              },
              {
                period: 122,
                totalMonthlyReturn: 7062.617290619042,
                monthlyInterestReturn: 2011.110708329011,
                additionalAmountDueToAdditionalFee: 1260.68001574432,
                monthlyFundReturn: 5051.506582290031,
                fundBalance: 712651.0347844716,
              },
              {
                period: 123,
                totalMonthlyReturn: 7074.619377102547,
                monthlyInterestReturn: 1999.9127362941676,
                additionalAmountDueToAdditionalFee: 1272.6821022278255,
                monthlyFundReturn: 5074.706640808379,
                fundBalance: 708836.2786852069,
              },
              {
                period: 124,
                totalMonthlyReturn: 7086.651468802261,
                monthlyInterestReturn: 1988.637428744701,
                additionalAmountDueToAdditionalFee: 1284.7141939275393,
                monthlyFundReturn: 5098.01404005756,
                fundBalance: 704992.2752774367,
              },
              {
                period: 125,
                totalMonthlyReturn: 7098.713640731225,
                monthlyInterestReturn: 1977.284360761499,
                additionalAmountDueToAdditionalFee: 1296.7763658565027,
                monthlyFundReturn: 5121.429279969726,
                fundBalance: 701118.8578765502,
              },
              {
                period: 126,
                totalMonthlyReturn: 7110.8059680900105,
                monthlyInterestReturn: 1965.8531052709436,
                additionalAmountDueToAdditionalFee: 1308.8686932152887,
                monthlyFundReturn: 5144.952862819067,
                fundBalance: 697215.8589356291,
              },
              {
                period: 127,
                totalMonthlyReturn: 7122.928526267193,
                monthlyInterestReturn: 1954.343233034353,
                additionalAmountDueToAdditionalFee: 1320.9912513924714,
                monthlyFundReturn: 5168.58529323284,
                fundBalance: 693283.1100411639,
              },
              {
                period: 128,
                totalMonthlyReturn: 7135.081390839819,
                monthlyInterestReturn: 1942.7543126373725,
                additionalAmountDueToAdditionalFee: 1333.1441159650972,
                monthlyFundReturn: 5192.3270782024465,
                fundBalance: 689320.4419087492,
              },
              {
                period: 129,
                totalMonthlyReturn: 7147.264637573877,
                monthlyInterestReturn: 1931.0859104793096,
                additionalAmountDueToAdditionalFee: 1345.3273626991545,
                monthlyFundReturn: 5216.178727094567,
                fundBalance: 685327.6843787582,
              },
              {
                period: 130,
                totalMonthlyReturn: 7159.478342424769,
                monthlyInterestReturn: 1919.3375907624254,
                additionalAmountDueToAdditionalFee: 1357.541067550047,
                monthlyFundReturn: 5240.140751662344,
                fundBalance: 681304.6664119961,
              },
              {
                period: 131,
                totalMonthlyReturn: 7171.722581537788,
                monthlyInterestReturn: 1907.5089154811685,
                additionalAmountDueToAdditionalFee: 1369.7853066630664,
                monthlyFundReturn: 5264.213666056619,
                fundBalance: 677251.2160853327,
              },
              {
                period: 132,
                totalMonthlyReturn: 7183.99743124859,
                monthlyInterestReturn: 1895.5994444113576,
                additionalAmountDueToAdditionalFee: 1382.0601563738683,
                monthlyFundReturn: 5288.397986837233,
                fundBalance: 673167.1605873125,
              },
              {
                period: 133,
                totalMonthlyReturn: 7196.302968083669,
                monthlyInterestReturn: 1883.608735099315,
                additionalAmountDueToAdditionalFee: 1394.3656932089475,
                monthlyFundReturn: 5312.694232984354,
                fundBalance: 669052.3262137448,
              },
              {
                period: 134,
                totalMonthlyReturn: 7208.639268760837,
                monthlyInterestReturn: 1871.5363428509438,
                additionalAmountDueToAdditionalFee: 1406.7019938861145,
                monthlyFundReturn: 5337.102925909892,
                fundBalance: 664906.5383632714,
              },
              {
                period: 135,
                totalMonthlyReturn: 7221.006410189696,
                monthlyInterestReturn: 1859.3818207207541,
                additionalAmountDueToAdditionalFee: 1419.0691353149741,
                monthlyFundReturn: 5361.624589468942,
                fundBalance: 660729.6215329128,
              },
              {
                period: 136,
                totalMonthlyReturn: 7233.404469472128,
                monthlyInterestReturn: 1847.1447195008377,
                additionalAmountDueToAdditionalFee: 1431.467194597406,
                monthlyFundReturn: 5386.25974997129,
                fundBalance: 656521.3993135936,
              },
              {
                period: 137,
                totalMonthlyReturn: 7245.833523902766,
                monthlyInterestReturn: 1834.824587709787,
                additionalAmountDueToAdditionalFee: 1443.8962490280442,
                monthlyFundReturn: 5411.008936192979,
                fundBalance: 652281.6943856443,
              },
              {
                period: 138,
                totalMonthlyReturn: 7258.293650969481,
                monthlyInterestReturn: 1822.4209715815612,
                additionalAmountDueToAdditionalFee: 1456.3563760947586,
                monthlyFundReturn: 5435.87267938792,
                fundBalance: 648010.3285142826,
              },
              {
                period: 139,
                totalMonthlyReturn: 7270.784928353862,
                monthlyInterestReturn: 1809.9334150542995,
                additionalAmountDueToAdditionalFee: 1468.8476534791403,
                monthlyFundReturn: 5460.8515132995635,
                fundBalance: 643707.122545073,
              },
              {
                period: 140,
                totalMonthlyReturn: 7283.3074339317045,
                monthlyInterestReturn: 1797.3614597590806,
                additionalAmountDueToAdditionalFee: 1481.3701590569826,
                monthlyFundReturn: 5485.945974172624,
                fundBalance: 639371.8963993622,
              },
              {
                period: 141,
                totalMonthlyReturn: 7295.861245773492,
                monthlyInterestReturn: 1784.7046450086254,
                additionalAmountDueToAdditionalFee: 1493.9239708987698,
                monthlyFundReturn: 5511.156600764867,
                fundBalance: 635004.4690696946,
              },
              {
                period: 142,
                totalMonthlyReturn: 7308.446442144883,
                monthlyInterestReturn: 1771.9625077859491,
                additionalAmountDueToAdditionalFee: 1506.509167270161,
                monthlyFundReturn: 5536.483934358934,
                fundBalance: 630604.658615204,
              },
              {
                period: 143,
                totalMonthlyReturn: 7321.063101507203,
                monthlyInterestReturn: 1759.1345827329546,
                additionalAmountDueToAdditionalFee: 1519.1258266324808,
                monthlyFundReturn: 5561.928518774248,
                fundBalance: 626172.282156983,
              },
              {
                period: 144,
                totalMonthlyReturn: 7333.711302517929,
                monthlyInterestReturn: 1746.2204021389741,
                additionalAmountDueToAdditionalFee: 1531.7740276432064,
                monthlyFundReturn: 5587.490900378954,
                fundBalance: 621707.1558734309,
              },
              {
                period: 145,
                totalMonthlyReturn: 7346.391124031181,
                monthlyInterestReturn: 1733.2194959292524,
                additionalAmountDueToAdditionalFee: 1544.453849156459,
                monthlyFundReturn: 5613.171628101929,
                fundBalance: 617209.0949955776,
              },
              {
                period: 146,
                totalMonthlyReturn: 7359.102645098216,
                monthlyInterestReturn: 1720.131391653378,
                additionalAmountDueToAdditionalFee: 1557.1653702234944,
                monthlyFundReturn: 5638.971253444838,
                fundBalance: 612677.9138023849,
              },
              {
                period: 147,
                totalMonthlyReturn: 7371.845944967919,
                monthlyInterestReturn: 1706.9556144736546,
                additionalAmountDueToAdditionalFee: 1569.9086700931975,
                monthlyFundReturn: 5664.890330494265,
                fundBalance: 608113.4256160258,
              },
              {
                period: 148,
                totalMonthlyReturn: 7384.621103087296,
                monthlyInterestReturn: 1693.6916871534208,
                additionalAmountDueToAdditionalFee: 1582.683828212575,
                monthlyFundReturn: 5690.929415933876,
                fundBalance: 603515.44279714,
              },
              {
                period: 149,
                totalMonthlyReturn: 7397.4281991019725,
                monthlyInterestReturn: 1680.3391300453088,
                additionalAmountDueToAdditionalFee: 1595.490924227251,
                monthlyFundReturn: 5717.089069056664,
                fundBalance: 598883.7767400666,
              },
              {
                period: 150,
                totalMonthlyReturn: 7410.267312856686,
                monthlyInterestReturn: 1666.8974610794494,
                additionalAmountDueToAdditionalFee: 1608.3300379819639,
                monthlyFundReturn: 5743.369851777237,
                fundBalance: 594218.237868053,
              },
              {
                period: 151,
                totalMonthlyReturn: 7423.138524395785,
                monthlyInterestReturn: 1653.3661957516206,
                additionalAmountDueToAdditionalFee: 1621.2012495210633,
                monthlyFundReturn: 5769.772328644165,
                fundBalance: 589518.6356284418,
              },
              {
                period: 152,
                totalMonthlyReturn: 7436.041913963732,
                monthlyInterestReturn: 1639.744847111336,
                additionalAmountDueToAdditionalFee: 1634.1046390890106,
                monthlyFundReturn: 5796.297066852397,
                fundBalance: 584784.778487832,
              },
              {
                period: 153,
                totalMonthlyReturn: 7448.977562005599,
                monthlyInterestReturn: 1626.0329257498788,
                additionalAmountDueToAdditionalFee: 1647.0402871308775,
                monthlyFundReturn: 5822.944636255721,
                fundBalance: 580016.4739272197,
              },
              {
                period: 154,
                totalMonthlyReturn: 7461.945549167571,
                monthlyInterestReturn: 1612.2299397882766,
                additionalAmountDueToAdditionalFee: 1660.0082742928494,
                monthlyFundReturn: 5849.715609379295,
                fundBalance: 575213.528437112,
              },
              {
                period: 155,
                totalMonthlyReturn: 7474.945956297448,
                monthlyInterestReturn: 1598.3353948652175,
                additionalAmountDueToAdditionalFee: 1673.008681422726,
                monthlyFundReturn: 5876.6105614322305,
                fundBalance: 570375.7475126187,
              },
              {
                period: 156,
                totalMonthlyReturn: 7487.978864445149,
                monthlyInterestReturn: 1584.3487941249102,
                additionalAmountDueToAdditionalFee: 1686.0415895704277,
                monthlyFundReturn: 5903.63007032024,
                fundBalance: 565502.9356485207,
              },
              {
                period: 157,
                totalMonthlyReturn: 7501.04435486322,
                monthlyInterestReturn: 1570.2696382048832,
                additionalAmountDueToAdditionalFee: 1699.1070799884988,
                monthlyFundReturn: 5930.774716658338,
                fundBalance: 560594.896334313,
              },
              {
                period: 158,
                totalMonthlyReturn: 7514.142509007336,
                monthlyInterestReturn: 1556.097425223726,
                additionalAmountDueToAdditionalFee: 1712.2052341326144,
                monthlyFundReturn: 5958.045083783611,
                fundBalance: 555651.4320492235,
              },
              {
                period: 159,
                totalMonthlyReturn: 7527.273408536812,
                monthlyInterestReturn: 1541.8316507687719,
                additionalAmountDueToAdditionalFee: 1725.3361336620906,
                monthlyFundReturn: 5985.441757768041,
                fundBalance: 550672.3442572095,
              },
              {
                period: 160,
                totalMonthlyReturn: 7540.437135315113,
                monthlyInterestReturn: 1527.4718078837195,
                additionalAmountDueToAdditionalFee: 1738.4998604403904,
                monthlyFundReturn: 6012.965327431393,
                fundBalance: 545657.433401927,
              },
              {
                period: 161,
                totalMonthlyReturn: 7553.633771410357,
                monthlyInterestReturn: 1513.0173870561975,
                additionalAmountDueToAdditionalFee: 1751.696496535636,
                monthlyFundReturn: 6040.61638435416,
                fundBalance: 540606.4989016782,
              },
              {
                period: 162,
                totalMonthlyReturn: 7566.8633990958415,
                monthlyInterestReturn: 1498.4678762052665,
                additionalAmountDueToAdditionalFee: 1764.92612422112,
                monthlyFundReturn: 6068.395522890576,
                fundBalance: 535519.3391443326,
              },
              {
                period: 163,
                totalMonthlyReturn: 7580.126100850539,
                monthlyInterestReturn: 1483.8227606688608,
                additionalAmountDueToAdditionalFee: 1778.188825975817,
                monthlyFundReturn: 6096.303340181677,
                fundBalance: 530395.7514822233,
              },
              {
                period: 164,
                totalMonthlyReturn: 7593.421959359623,
                monthlyInterestReturn: 1469.0815231911727,
                additionalAmountDueToAdditionalFee: 1791.4846844849012,
                monthlyFundReturn: 6124.340436168451,
                fundBalance: 525235.5322270201,
              },
              {
                period: 165,
                totalMonthlyReturn: 7606.75105751498,
                monthlyInterestReturn: 1454.2436439099718,
                additionalAmountDueToAdditionalFee: 1804.813782640258,
                monthlyFundReturn: 6152.507413605008,
                fundBalance: 520038.47664457595,
              },
              {
                period: 166,
                totalMonthlyReturn: 7620.113478415726,
                monthlyInterestReturn: 1439.3086003438668,
                additionalAmountDueToAdditionalFee: 1818.176203541003,
                monthlyFundReturn: 6180.804878071858,
                fundBalance: 514804.37894974917,
              },
              {
                period: 167,
                totalMonthlyReturn: 7633.5093053687215,
                monthlyInterestReturn: 1424.2758673795029,
                additionalAmountDueToAdditionalFee: 1831.5720304939996,
                monthlyFundReturn: 6209.233437989218,
                fundBalance: 509533.03230120003,
              },
              {
                period: 168,
                totalMonthlyReturn: 7646.938621889101,
                monthlyInterestReturn: 1409.144917258699,
                additionalAmountDueToAdditionalFee: 1845.001347014379,
                monthlyFundReturn: 6237.793704630401,
                fundBalance: 504224.22879616224,
              },
              {
                period: 169,
                totalMonthlyReturn: 7660.40151170078,
                monthlyInterestReturn: 1393.9152195655238,
                additionalAmountDueToAdditionalFee: 1858.4642368260593,
                monthlyFundReturn: 6266.486292135258,
                fundBalance: 498877.7594651887,
              },
              {
                period: 170,
                totalMonthlyReturn: 7673.898058736991,
                monthlyInterestReturn: 1378.5862412133058,
                additionalAmountDueToAdditionalFee: 1871.9607838622687,
                monthlyFundReturn: 6295.311817523685,
                fundBalance: 493493.41426687234,
              },
              {
                period: 171,
                totalMonthlyReturn: 7687.428347140791,
                monthlyInterestReturn: 1363.1574464315856,
                additionalAmountDueToAdditionalFee: 1885.4910722660688,
                monthlyFundReturn: 6324.270900709205,
                fundBalance: 488070.9820825402,
              },
              {
                period: 172,
                totalMonthlyReturn: 7700.9924612656,
                monthlyInterestReturn: 1347.6282967530026,
                additionalAmountDueToAdditionalFee: 1899.0551863908786,
                monthlyFundReturn: 6353.364164512597,
                fundBalance: 482610.25071092276,
              },
              {
                period: 173,
                totalMonthlyReturn: 7714.590485675722,
                monthlyInterestReturn: 1331.9982510001169,
                additionalAmountDueToAdditionalFee: 1912.6532108010006,
                monthlyFundReturn: 6382.592234675606,
                fundBalance: 477111.00686279626,
              },
              {
                period: 174,
                totalMonthlyReturn: 7728.2225051468695,
                monthlyInterestReturn: 1316.2667652721716,
                additionalAmountDueToAdditionalFee: 1926.2852302721476,
                monthlyFundReturn: 6411.955739874698,
                fundBalance: 471573.0361556,
              },
              {
                period: 175,
                totalMonthlyReturn: 7741.888604666694,
                monthlyInterestReturn: 1300.433292931788,
                additionalAmountDueToAdditionalFee: 1939.9513297919725,
                monthlyFundReturn: 6441.455311734906,
                fundBalance: 465996.1231080265,
              },
              {
                period: 176,
                totalMonthlyReturn: 7755.588869435318,
                monthlyInterestReturn: 1284.4972845915986,
                additionalAmountDueToAdditionalFee: 1953.6515945605965,
                monthlyFundReturn: 6471.09158484372,
                fundBalance: 460380.0511345861,
              },
              {
                period: 177,
                totalMonthlyReturn: 7769.323384865864,
                monthlyInterestReturn: 1268.458188100814,
                additionalAmountDueToAdditionalFee: 1967.3861099911428,
                monthlyFundReturn: 6500.865196765051,
                fundBalance: 454724.6025401442,
              },
              {
                period: 178,
                totalMonthlyReturn: 7783.092236584987,
                monthlyInterestReturn: 1252.3154485317261,
                additionalAmountDueToAdditionalFee: 1981.1549617102655,
                monthlyFundReturn: 6530.776788053261,
                fundBalance: 449029.55851443287,
              },
              {
                period: 179,
                totalMonthlyReturn: 7796.895510433407,
                monthlyInterestReturn: 1236.0685081661463,
                additionalAmountDueToAdditionalFee: 1994.9582355586858,
                monthlyFundReturn: 6560.827002267262,
                fundBalance: 443294.69912653515,
              },
              {
                period: 180,
                totalMonthlyReturn: 7810.733292466448,
                monthlyInterestReturn: 1219.7168064817783,
                additionalAmountDueToAdditionalFee: 2008.796017591727,
                monthlyFundReturn: 6591.016485984671,
                fundBalance: 437519.8033193428,
              },
              {
                period: 181,
                totalMonthlyReturn: 7824.605668954573,
                monthlyInterestReturn: 1203.259780138524,
                additionalAmountDueToAdditionalFee: 2022.6683940798512,
                monthlyFundReturn: 6621.345888816049,
                fundBalance: 431704.6489039862,
              },
              {
                period: 182,
                totalMonthlyReturn: 7838.512726383917,
                monthlyInterestReturn: 1186.696862964725,
                additionalAmountDueToAdditionalFee: 2036.5754515091953,
                monthlyFundReturn: 6651.815863419191,
                fundBalance: 425849.0125542391,
              },
              {
                period: 183,
                totalMonthlyReturn: 7852.454551456835,
                monthlyInterestReturn: 1170.0274859433357,
                additionalAmountDueToAdditionalFee: 2050.517276582113,
                monthlyFundReturn: 6682.427065513499,
                fundBalance: 419952.66980089375,
              },
              {
                period: 184,
                totalMonthlyReturn: 7866.431231092434,
                monthlyInterestReturn: 1153.251077198034,
                additionalAmountDueToAdditionalFee: 2064.493956217713,
                monthlyFundReturn: 6713.1801538944,
                fundBalance: 414015.3950261103,
              },
              {
                period: 185,
                totalMonthlyReturn: 7880.442852427123,
                monthlyInterestReturn: 1136.3670619792588,
                additionalAmountDueToAdditionalFee: 2078.5055775524015,
                monthlyFundReturn: 6744.075790447865,
                fundBalance: 408036.9614577382,
              },
              {
                period: 186,
                totalMonthlyReturn: 7894.4895028151495,
                monthlyInterestReturn: 1119.3748626501858,
                additionalAmountDueToAdditionalFee: 2092.552227940427,
                monthlyFundReturn: 6775.114640164964,
                fundBalance: 402017.1411636097,
              },
              {
                period: 187,
                totalMonthlyReturn: 7908.5712698291445,
                monthlyInterestReturn: 1102.2738986726317,
                additionalAmountDueToAdditionalFee: 2106.6339949544226,
                monthlyFundReturn: 6806.297371156514,
                fundBalance: 395955.705045806,
              },
              {
                period: 188,
                totalMonthlyReturn: 7922.688241260675,
                monthlyInterestReturn: 1085.0635865928944,
                additionalAmountDueToAdditionalFee: 2120.7509663859532,
                monthlyFundReturn: 6837.624654667781,
                fundBalance: 389852.4228348954,
              },
              {
                period: 189,
                totalMonthlyReturn: 7936.840505120785,
                monthlyInterestReturn: 1067.7433400275195,
                additionalAmountDueToAdditionalFee: 2134.903230246063,
                monthlyFundReturn: 6869.097165093264,
                fundBalance: 383707.063084143,
              },
              {
                period: 190,
                totalMonthlyReturn: 7951.028149640544,
                monthlyInterestReturn: 1050.3125696490042,
                additionalAmountDueToAdditionalFee: 2149.0908747658223,
                monthlyFundReturn: 6900.71557999154,
                fundBalance: 377519.3931636929,
              },
              {
                period: 191,
                totalMonthlyReturn: 7965.251263271603,
                monthlyInterestReturn: 1032.7706831714286,
                additionalAmountDueToAdditionalFee: 2163.3139883968815,
                monthlyFundReturn: 6932.480580100175,
                fundBalance: 371289.1792547215,
              },
              {
                period: 192,
                totalMonthlyReturn: 7979.509934686739,
                monthlyInterestReturn: 1015.1170853360178,
                additionalAmountDueToAdditionalFee: 2177.572659812018,
                monthlyFundReturn: 6964.392849350722,
                fundBalance: 365016.1863435627,
              },
              {
                period: 193,
                totalMonthlyReturn: 7993.8042527804155,
                monthlyInterestReturn: 997.3511778966359,
                additionalAmountDueToAdditionalFee: 2191.8669779056927,
                monthlyFundReturn: 6996.453074883779,
                fundBalance: 358700.1782158043,
              },
              {
                period: 194,
                totalMonthlyReturn: 8008.134306669323,
                monthlyInterestReturn: 979.4723596052098,
                additionalAmountDueToAdditionalFee: 2206.1970317946016,
                monthlyFundReturn: 7028.661947064114,
                fundBalance: 352340.9174503558,
              },
              {
                period: 195,
                totalMonthlyReturn: 8022.500185692955,
                monthlyInterestReturn: 961.4800261970813,
                additionalAmountDueToAdditionalFee: 2220.5629108182325,
                monthlyFundReturn: 7061.020159495873,
                fundBalance: 345938.1654134874,
              },
              {
                period: 196,
                totalMonthlyReturn: 8036.901979414144,
                monthlyInterestReturn: 943.3735703762902,
                additionalAmountDueToAdditionalFee: 2234.964704539422,
                monthlyFundReturn: 7093.528409037854,
                fundBalance: 339491.68225283985,
              },
              {
                period: 197,
                totalMonthlyReturn: 8051.339777619638,
                monthlyInterestReturn: 925.1523818007861,
                additionalAmountDueToAdditionalFee: 2249.4025027449156,
                monthlyFundReturn: 7126.187395818851,
                fundBalance: 333001.22689140507,
              },
              {
                period: 198,
                totalMonthlyReturn: 8065.8136703206455,
                monthlyInterestReturn: 906.8158470675679,
                additionalAmountDueToAdditionalFee: 2263.8763954459228,
                monthlyFundReturn: 7158.9978232530775,
                fundBalance: 326466.5570214778,
              },
              {
                period: 199,
                totalMonthlyReturn: 8080.323747753404,
                monthlyInterestReturn: 888.3633496977536,
                additionalAmountDueToAdditionalFee: 2278.386472878682,
                monthlyFundReturn: 7191.960398055649,
                fundBalance: 319887.4290985776,
              },
              {
                period: 200,
                totalMonthlyReturn: 8094.870100379745,
                monthlyInterestReturn: 869.7942701215763,
                additionalAmountDueToAdditionalFee: 2292.932825505023,
                monthlyFundReturn: 7225.075830258169,
                fundBalance: 313263.59833534126,
              },
              {
                period: 201,
                totalMonthlyReturn: 8109.452818887652,
                monthlyInterestReturn: 851.1079856633089,
                additionalAmountDueToAdditionalFee: 2307.51554401293,
                monthlyFundReturn: 7258.344833224342,
                fundBalance: 306594.81869538565,
              },
              {
                period: 202,
                totalMonthlyReturn: 8124.071994191829,
                monthlyInterestReturn: 832.3038705261156,
                additionalAmountDueToAdditionalFee: 2322.1347193171073,
                monthlyFundReturn: 7291.768123665714,
                fundBalance: 299880.84288714064,
              },
              {
                period: 203,
                totalMonthlyReturn: 8138.727717434267,
                monthlyInterestReturn: 813.381295776831,
                additionalAmountDueToAdditionalFee: 2336.7904425595443,
                monthlyFundReturn: 7325.346421657436,
                fundBalance: 293121.4223576518,
              },
              {
                period: 204,
                totalMonthlyReturn: 8153.4200799848095,
                monthlyInterestReturn: 794.3396293306657,
                additionalAmountDueToAdditionalFee: 2351.4828051100876,
                monthlyFundReturn: 7359.080450654144,
                fundBalance: 286316.3072863536,
              },
              {
                period: 205,
                totalMonthlyReturn: 8168.149173441729,
                monthlyInterestReturn: 775.1782359358372,
                additionalAmountDueToAdditionalFee: 2366.211898567007,
                monthlyFundReturn: 7392.970937505892,
                fundBalance: 279465.2465788114,
              },
              {
                period: 206,
                totalMonthlyReturn: 8182.91508963229,
                monthlyInterestReturn: 755.8964771581287,
                additionalAmountDueToAdditionalFee: 2380.977814757569,
                monthlyFundReturn: 7427.018612474162,
                fundBalance: 272567.98786043364,
              },
              {
                period: 207,
                totalMonthlyReturn: 8197.71792061333,
                monthlyInterestReturn: 736.4937113653715,
                additionalAmountDueToAdditionalFee: 2395.7806457386073,
                monthlyFundReturn: 7461.224209247957,
                fundBalance: 265624.27747015376,
              },
              {
                period: 208,
                totalMonthlyReturn: 8212.557758671821,
                monthlyInterestReturn: 716.969293711854,
                additionalAmountDueToAdditionalFee: 2410.620483797098,
                monthlyFundReturn: 7495.588464959967,
                fundBalance: 258633.8604540801,
              },
              {
                period: 209,
                totalMonthlyReturn: 8227.434696325457,
                monthlyInterestReturn: 697.3225761226548,
                additionalAmountDueToAdditionalFee: 2425.497421450735,
                monthlyFundReturn: 7530.1121202028025,
                fundBalance: 251596.4805591164,
              },
              {
                period: 210,
                totalMonthlyReturn: 8242.348826323228,
                monthlyInterestReturn: 677.5529072779005,
                additionalAmountDueToAdditionalFee: 2440.4115514485065,
                monthlyFundReturn: 7564.795919045328,
                fundBalance: 244511.88022655045,
              },
              {
                period: 211,
                totalMonthlyReturn: 8257.300241645993,
                monthlyInterestReturn: 657.6596325969483,
                additionalAmountDueToAdditionalFee: 2455.362966771272,
                monthlyFundReturn: 7599.640609049046,
                fundBalance: 237379.80058561155,
              },
              {
                period: 212,
                totalMonthlyReturn: 8272.289035507067,
                monthlyInterestReturn: 637.6420942224912,
                additionalAmountDueToAdditionalFee: 2470.351760632345,
                monthlyFundReturn: 7634.646941284575,
                fundBalance: 230199.98144699697,
              },
              {
                period: 213,
                totalMonthlyReturn: 8287.315301352792,
                monthlyInterestReturn: 617.4996310045874,
                additionalAmountDueToAdditionalFee: 2485.3780264780703,
                monthlyFundReturn: 7669.815670348205,
                fundBalance: 222972.16129636683,
              },
              {
                period: 214,
                totalMonthlyReturn: 8302.379132863132,
                monthlyInterestReturn: 597.2315784846129,
                additionalAmountDueToAdditionalFee: 2500.44185798841,
                monthlyFundReturn: 7705.147554378518,
                fundBalance: 215696.07728780716,
              },
              {
                period: 215,
                totalMonthlyReturn: 8317.480623952248,
                monthlyInterestReturn: 576.8372688791361,
                additionalAmountDueToAdditionalFee: 2515.5433490775254,
                monthlyFundReturn: 7740.643355073111,
                fundBalance: 208371.46523726138,
              },
              {
                period: 216,
                totalMonthlyReturn: 8332.619868769085,
                monthlyInterestReturn: 556.3160310637153,
                additionalAmountDueToAdditionalFee: 2530.682593894364,
                monthlyFundReturn: 7776.303837705371,
                fundBalance: 200998.05961592981,
              },
              {
                period: 217,
                totalMonthlyReturn: 8347.796961697966,
                monthlyInterestReturn: 535.6671905566182,
                additionalAmountDueToAdditionalFee: 2545.8596868232444,
                monthlyFundReturn: 7812.129771141348,
                fundBalance: 193575.593543637,
              },
              {
                period: 218,
                totalMonthlyReturn: 8363.011997359168,
                monthlyInterestReturn: 514.890069502462,
                additionalAmountDueToAdditionalFee: 2561.0747224844467,
                monthlyFundReturn: 7848.121927856707,
                fundBalance: 186103.79878216676,
              },
              {
                period: 219,
                totalMonthlyReturn: 8378.265070609525,
                monthlyInterestReturn: 493.9839866557761,
                additionalAmountDueToAdditionalFee: 2576.3277957348023,
                monthlyFundReturn: 7884.281083953748,
                fundBalance: 178582.40572856512,
              },
              {
                period: 220,
                totalMonthlyReturn: 8393.556276543006,
                monthlyInterestReturn: 472.9482573644848,
                additionalAmountDueToAdditionalFee: 2591.6190016682835,
                monthlyFundReturn: 7920.60801917852,
                fundBalance: 171011.14340841025,
              },
              {
                period: 221,
                totalMonthlyReturn: 8408.88571049132,
                monthlyInterestReturn: 451.78219355331,
                additionalAmountDueToAdditionalFee: 2606.9484356165985,
                monthlyFundReturn: 7957.10351693801,
                fundBalance: 163389.73946905014,
              },
              {
                period: 222,
                totalMonthlyReturn: 8424.253468024508,
                monthlyInterestReturn: 430.4851037070955,
                additionalAmountDueToAdditionalFee: 2622.316193149785,
                monthlyFundReturn: 7993.7683643174105,
                fundBalance: 155717.92017280695,
              },
              {
                period: 223,
                totalMonthlyReturn: 8439.659644951527,
                monthlyInterestReturn: 409.056292854049,
                additionalAmountDueToAdditionalFee: 2637.722370076804,
                monthlyFundReturn: 8030.603352097477,
                fundBalance: 147995.41039014867,
              },
              {
                period: 224,
                totalMonthlyReturn: 8455.104337320863,
                monthlyInterestReturn: 387.4950625489046,
                additionalAmountDueToAdditionalFee: 2653.167062446141,
                monthlyFundReturn: 8067.609274771958,
                fundBalance: 140221.93359282735,
              },
              {
                period: 225,
                totalMonthlyReturn: 8470.587641421122,
                monthlyInterestReturn: 365.8007108560048,
                additionalAmountDueToAdditionalFee: 2668.6503665464006,
                monthlyFundReturn: 8104.7869305651175,
                fundBalance: 132397.21184698434,
              },
              {
                period: 226,
                totalMonthlyReturn: 8486.109653781634,
                monthlyInterestReturn: 343.9725323322989,
                additionalAmountDueToAdditionalFee: 2684.172378906911,
                monthlyFundReturn: 8142.137121449334,
                fundBalance: 124520.96580622136,
              },
              {
                period: 227,
                totalMonthlyReturn: 8501.670471173045,
                monthlyInterestReturn: 322.0098180102615,
                additionalAmountDueToAdditionalFee: 2699.7331962983226,
                monthlyFundReturn: 8179.660653162783,
                fundBalance: 116592.91470463865,
              },
              {
                period: 228,
                totalMonthlyReturn: 8517.270190607935,
                monthlyInterestReturn: 299.91185538072807,
                additionalAmountDueToAdditionalFee: 2715.3329157332128,
                monthlyFundReturn: 8217.358335227207,
                fundBalance: 108612.77634983876,
              },
              {
                period: 229,
                totalMonthlyReturn: 8532.908909341411,
                monthlyInterestReturn: 277.6779283756474,
                additionalAmountDueToAdditionalFee: 2730.97163446669,
                monthlyFundReturn: 8255.230980965765,
                fundBalance: 100580.26711589645,
              },
              {
                period: 230,
                totalMonthlyReturn: 8548.586724871722,
                monthlyInterestReturn: 255.30731735075167,
                additionalAmountDueToAdditionalFee: 2746.6494499970013,
                monthlyFundReturn: 8293.279407520971,
                fundBalance: 92495.10193629458,
              },
              {
                period: 231,
                totalMonthlyReturn: 8564.303734940859,
                monthlyInterestReturn: 232.79929906814266,
                additionalAmountDueToAdditionalFee: 2762.366460066138,
                monthlyFundReturn: 8331.504435872717,
                fundBalance: 84356.99429682546,
              },
              {
                period: 232,
                totalMonthlyReturn: 8580.06003753517,
                monthlyInterestReturn: 210.15314667879414,
                additionalAmountDueToAdditionalFee: 2778.1227626604477,
                monthlyFundReturn: 8369.906890856375,
                fundBalance: 76165.65622845784,
              },
              {
                period: 233,
                totalMonthlyReturn: 8595.855730885965,
                monthlyInterestReturn: 187.3681297049702,
                additionalAmountDueToAdditionalFee: 2793.9184560112435,
                monthlyFundReturn: 8408.487601180994,
                fundBalance: 67920.7983001692,
              },
              {
                period: 234,
                totalMonthlyReturn: 8611.690913470138,
                monthlyInterestReturn: 164.44351402255847,
                additionalAmountDueToAdditionalFee: 2809.753638595416,
                monthlyFundReturn: 8447.247399447579,
                fundBalance: 59622.12961174312,
              },
              {
                period: 235,
                totalMonthlyReturn: 8627.565684010771,
                monthlyInterestReturn: 141.37856184331895,
                additionalAmountDueToAdditionalFee: 2825.628409136049,
                monthlyFundReturn: 8486.187122167452,
                fundBalance: 51269.35778653179,
              },
              {
                period: 236,
                totalMonthlyReturn: 8643.480141477756,
                monthlyInterestReturn: 118.17253169704651,
                additionalAmountDueToAdditionalFee: 2841.5428666030334,
                monthlyFundReturn: 8525.30760978071,
                fundBalance: 42862.18896418328,
              },
              {
                period: 237,
                totalMonthlyReturn: 8659.434385088407,
                monthlyInterestReturn: 94.82467841364833,
                additionalAmountDueToAdditionalFee: 2857.497110213685,
                monthlyFundReturn: 8564.609706674757,
                fundBalance: 34400.32779333339,
              },
              {
                period: 238,
                totalMonthlyReturn: 8675.428514308085,
                monthlyInterestReturn: 71.33425310513434,
                additionalAmountDueToAdditionalFee: 2873.4912394333637,
                monthlyFundReturn: 8604.094261202952,
                fundBalance: 25883.477424262168,
              },
              {
                period: 239,
                totalMonthlyReturn: 8691.462628850813,
                monthlyInterestReturn: 47.70050314752139,
                additionalAmountDueToAdditionalFee: 2889.5253539760915,
                monthlyFundReturn: 8643.762125703292,
                fundBalance: 17311.339501514576,
              },
              {
                period: 240,
                totalMonthlyReturn: 8707.536828679898,
                monthlyInterestReturn: 23.922672162650134,
                additionalAmountDueToAdditionalFee: 2905.599553805176,
                monthlyFundReturn: 8683.614156517247,
                fundBalance: 8683.6141564854,
              },
            ],
            maxMonthlyReturn: 8707.536828679898,
            minMonthlyReturn: 5810.787661318866,
            totalReturn: 1707973.2684079322,
            totalInterestReturn: 441839.9356667936,
            returnConversion: 1.7079732684079323,
          },
        ],
      },
    },
    status: 200,
  },

  error: {
    response: {
      createdAt: 1701115461239,
      object: 'login',
      success: false,
    },
    status: 500,
  },
};

const retrievalHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(2000);
  return HttpResponse.json(response, status);
};

export {
  retrievalHandler,
};
